const SummaryTableSchema = [{
  objectName: 'overchargeDialogSummary',
  isLoading: 'loadingOverchargeDialogSummary',
  label: 'Totals',
  children: [
    {
      label: 'RFC TOTAL',
      fieldNames: [
        'RFCTotalDisplay',
      ],
    },
    {
      label: 'TAX TOTAL',
      fieldNames: [
        'TaxTotalDisplay',
      ]
    }
  ]
}];

export default SummaryTableSchema;
